import { Event } from "../events/Event";
import { ILaya } from "../../ILaya";
import { PAL } from "../platform/PlatformAdapters";
import { MathUtil } from "../maths/MathUtil";
export class SoundManager {
    static __init__() {
        ILaya.stage.on(Event.BLUR, () => {
            if (mgr.autoStopMusic && mgr._musicChannel && !mgr._musicChannel.paused)
                PAL.media.resumeUntilGotFocus(mgr._musicChannel);
        });
    }
    static get musicVolume() {
        return mgr._musicVolume;
    }
    static set musicVolume(value) {
        value = MathUtil.clamp(value, 0, 1);
        if (value !== mgr._musicVolume) {
            mgr._musicVolume = value;
            if (mgr._musicChannel)
                mgr._musicChannel.volume = mgr._musicChannel.volume;
        }
    }
    static get soundVolume() {
        return mgr._soundVolume;
    }
    static set soundVolume(value) {
        value = MathUtil.clamp(value, 0, 1);
        if (value !== mgr._soundVolume) {
            mgr._soundVolume = value;
            for (let channel of mgr._channels) {
                if (channel !== mgr._musicChannel) {
                    channel.volume = channel.volume;
                }
            }
        }
    }
    static get muted() {
        return mgr._muted;
    }
    static set muted(value) {
        value = !!value;
        if (value !== mgr._muted) {
            mgr._muted = value;
            this.updateMutedStatus();
        }
    }
    static get soundMuted() {
        return mgr._soundMuted;
    }
    static set soundMuted(value) {
        value = !!value;
        if (value !== mgr._soundMuted) {
            mgr._soundMuted = value;
            this.updateMutedStatus();
        }
    }
    static get musicMuted() {
        return mgr._musicMuted;
    }
    static set musicMuted(value) {
        value = !!value;
        if (value !== mgr._musicMuted) {
            mgr._musicMuted = value;
            this.updateMutedStatus();
        }
    }
    static playSound(url, loops, complete, soundClass, startTime) {
        if (!url)
            return null;
        if (typeof (soundClass) === 'number')
            startTime = soundClass;
        let channel = PAL.media.createSoundChannel(url, false);
        channel._isMusic = false;
        channel.loops = loops !== null && loops !== void 0 ? loops : 1;
        channel.startTime = startTime !== null && startTime !== void 0 ? startTime : 0;
        channel.playbackRate = this.playbackRate;
        channel.volume = 1;
        channel.muted = mgr._soundMuted || mgr._muted;
        channel.completeHandler = complete;
        channel.play();
        return channel;
    }
    static playMusic(url, loops, complete, startTime) {
        if (mgr._musicChannel) {
            mgr._musicChannel.stop();
            mgr._musicChannel = null;
        }
        if (!url)
            return null;
        let channel = PAL.media.createSoundChannel(url, mgr.useAudioMusic);
        channel._isMusic = true;
        channel.loops = loops !== null && loops !== void 0 ? loops : 1;
        channel.startTime = startTime !== null && startTime !== void 0 ? startTime : 0;
        channel.playbackRate = this.playbackRate;
        channel.volume = 1;
        channel.muted = mgr._musicMuted || mgr._muted;
        channel.completeHandler = complete;
        channel.play();
        return channel;
    }
    static stopSound(url) {
        for (let channel of mgr._channels) {
            if (channel.url == url) {
                channel.stop();
                if (channel === mgr._musicChannel) {
                    mgr._musicChannel = null;
                }
            }
        }
    }
    static stopAll() {
        mgr._musicChannel = null;
        for (let channel of mgr._channels)
            channel.stop();
    }
    static stopAllSound() {
        for (let channel of mgr._channels) {
            if (channel !== mgr._musicChannel) {
                channel.stop();
            }
        }
    }
    static stopMusic() {
        if (mgr._musicChannel)
            mgr._musicChannel.stop();
        mgr._musicChannel = null;
    }
    static setSoundVolume(volume, url) {
        if (url) {
            let channel = this.findChannel(url);
            if (channel)
                channel.volume = volume;
        }
        else {
            this.soundVolume = volume;
        }
    }
    static setMusicVolume(volume) {
        this.musicVolume = volume;
    }
    static findChannel(url) {
        for (let channel of mgr._channels) {
            if (channel.url == url) {
                return channel;
            }
        }
        return null;
    }
    static updateMutedStatus() {
        let s = mgr._muted || mgr._soundMuted;
        let m = mgr._muted || mgr._musicMuted;
        for (let channel of mgr._channels) {
            if (channel === mgr._musicChannel)
                channel.muted = m;
            else
                channel.muted = s;
        }
    }
    static addChannel(channel) {
        mgr._channels.add(channel);
        if (channel._isMusic)
            mgr._musicChannel = channel;
    }
    static removeChannel(channel) {
        mgr._channels.delete(channel);
        if (channel === mgr._musicChannel)
            mgr._musicChannel = null;
    }
}
SoundManager.playbackRate = 1;
SoundManager.useAudioMusic = true;
SoundManager.autoStopMusic = true;
SoundManager._muted = false;
SoundManager._soundMuted = false;
SoundManager._musicMuted = false;
SoundManager._musicVolume = 1;
SoundManager._soundVolume = 1;
SoundManager._musicChannel = null;
SoundManager._channels = new Set();
const mgr = SoundManager;
